import React from 'react';
import styled from 'styled-components';

const ToggleContainer = styled.button<{ $isDark: boolean }>`
  position: relative;
  height: 30px;
  width: 68px;
  border: none;
  cursor: pointer;
  padding: 0;
  background: transparent;
  outline: none;
  background: ${props =>
    props.$isDark
      ? 'url(/images/global/icon_night.svg) no-repeat 10% 4px, linear-gradient(184deg, #2B4485 6.6%, #AFCAFF 96.98%)'
      : 'url(/images/global/icon_daylight.svg) no-repeat 80% 4px, linear-gradient(180deg, #66FFED 0%, #FFEEB2 100%)'
  };
  border-radius: ${props => props.theme.borderRadius.full};
  overflow: hidden;
  box-shadow: 0 6px 8px 3px rgba(0, 0, 0, 0.25) inset;
`;

const ToggleSlider = styled.div<{ $isDark: boolean }>`
  position: absolute;
  top: 2.5px;
  height: 25px;
  width: 38px;
  border-radius: ${props => props.theme.borderRadius.full};
  background: ${props =>
    props.$isDark
      ? 'linear-gradient(to bottom, #DDEDFF, #9FB8DD)'
      : 'linear-gradient(to bottom, #FFC123, #F8832E)'
  };
  border: 2px solid ${props =>
    props.$isDark
      ? '#D4E8FF'
      : '#FF9255'
  };
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  left: ${props => props.$isDark ? '27.5px' : '2.5px'};
  z-index: 1;
`;

interface DarkModeToggleProps {
  isDark: boolean;
  onToggle: () => void;
}

const TOGGLE_PATH = 'M0 15C0 7.13042 6.0788 0.596755 13.944 0.333237C19.4223 0.149688 26.2621 0 34 0C41.7379 0 48.5777 0.149688 54.056 0.333237C61.9212 0.596755 68 7.13042 68 15C68 22.8696 61.9212 29.4032 54.056 29.6668C48.5777 29.8503 41.7379 30 34 30C26.2621 30 19.4223 29.8503 13.944 29.6668C6.0788 29.4032 0 22.8696 0 15Z';

const DarkModeToggle: React.FC<DarkModeToggleProps> = ({ isDark, onToggle }) => {
  return (
    <ToggleContainer $isDark={isDark} onClick={onToggle} aria-label={isDark ? '라이트 모드로 전환' : '다크 모드로 전환'}>
      <ToggleSlider $isDark={isDark} />
    </ToggleContainer>
  );
};

export default DarkModeToggle;